module.exports = __webpack_public_path__ + "static/the_lost-3b7ec67aa4f59b20da7527682a9ceef4.png";